import React from "react";
import Helmet from "react-helmet";

export default () => (
  <Helmet
    script={[
      {
        type: "text/javascript",
        src: `https://ws.zoominfo.com/pixel/53wVNAC5Hfwfa2TywBys`
      }
    ]}
  />
);
